import { getCurrentInstance, computed, reactive } from 'vue';
import { ModuleActivity } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheActivityComboConfig = () => {
  const store = useStore();

  const activityCombo = computed(() => {
    const activities = store.getters[`${ModuleActivity}/items`];
    return activities.filter(x => !x.inactive && !x.is_parent);
  });

  // config columns combo
  const cacheActivityComboConfig = reactive({
    data: activityCombo,
    displayField: 'activity_name',
    valueField: 'activity_id',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'activity_id',
      titleSearch: 'Tìm nhanh hoạt động',
      columnDefault: [
        {
          title: 'Mã hoạt động',
          dataField: 'activity_code',
          width: 100,
          // filterOperator: proxy.$ms.constant.FilterOperator.StartsWith
        },
        {
          title: 'Tên hoạt động',
          dataField: 'activity_name',
          width: 500,
          // filterOperator: proxy.$ms.constant.FilterOperator.Contains
        },
      ],
    },
  });

  return { cacheActivityComboConfig };
};
